import { Store } from '@tencent/workbench-core';
import { setCustomMetadata, Use } from '@tencent/workbench';

/**
 * @public
 */
function Form(name, callbackName, customMetadata) {
    return Store.decorate((store) => {
        var _a;
        const points = (_a = store.get('points')) !== null && _a !== void 0 ? _a : [];
        const point = {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            from: 'form', name, trigger: callbackName, path: [],
        };
        store.set('points', points.concat([point]));
        setCustomMetadata(point, store, customMetadata);
        return Use('Form');
    });
}

export { Form };
//# sourceMappingURL=form.js.map
